module.exports = __webpack_public_path__ + "img/liststudent.7b13bfa4.svg";